export default {
  "de-DE": {
    "404": "Die gewünschte Seite wurde nicht gefunden.",
    "500": "Ein Fehler ist aufgetreten.",
    "503": "Die Seite ist momentan überlastet. Bitte versuche es später erneut.",
    "btn001": "Zurück zur Startseite",
    "voted": "Du hast deine Wahl bereits getroffen."
  },
  "en-GB": {
    "404": "The requested page could not be found.",
    "500": "An error has occurred.",
    "503": "The site is currently experiencing heavy use. Please try again later.",
    "btn001": "Return to the home page.",
    "voted": "You have already made your choice."
  },
  "es-ES": {
    "404": "No se ha encontrado la página solicitada.",
    "500": "Se ha producido un error.",
    "503": "La página está recibiendo muchas visitas. Inténtalo más tarde.",
    "btn001": "Volver a la página principal",
    "voted": "Ya has emitido un voto hoy."
  },
  "fr-FR": {
    "404": "La page demandée est introuvable.",
    "500": "Une erreur est survenue.",
    "503": "Le site est actuellement surchargé. Réessayez plus tard.",
    "btn001": "Retour à la page d'accueil",
    "voted": "Vous avez déjà voté aujourd'hui."
  },
  "it-IT": {
    "404": "La pagina che cerchi non è stata trovata.",
    "500": "Si è verificato un errore.",
    "503": "Il sito è bloccato a causa dell'alto volume di traffico. Riprova più tardi.",
    "btn001": "Torna alla pagina principale",
    "voted": "Hai già fatto la tua scelta."
  },
  "ja-JP": {
    "404": "お探しのページが見つかりません",
    "500": "エラーが発生しました",
    "503": "ただいま大変込み合っています",
    "btn001": "トップに戻る",
    "voted": "既に投票済みです"
  },
  "zh-TW": {
    "404": "無法顯示網頁",
    "500": "網頁發生錯誤",
    "503": "瀏覽人數過多",
    "btn001": "回到首頁",
    "voted": "已完成投票"
  },
  "en-US": {
    "404": "The requested page could not be found.",
    "500": "An error has occurred.",
    "503": "The site is currently experiencing heavy use. Please try again later.",
    "btn001": "Return to the Home Page",
    "voted": "You have already made your choice."
  },
  "es-MX": {
    "404": "No se ha encontrado la página solicitada.",
    "500": "Se produjo un error.",
    "503": "La página está recibiendo muchas visitas. Inténtalo más tarde.",
    "btn001": "Volver a la página principal",
    "voted": "Ya votaste hoy."
  },
  "fr-CA": {
    "404": "La page demandée est introuvable.",
    "500": "Une erreur est survenue.",
    "503": "Le site est actuellement surchargé. Réessayez plus tard.",
    "btn001": "Retour à la page d'accueil",
    "voted": "Vous avez déjà voté aujourd'hui."
  },
  "pt-BR": {
    "404": "Página não encontrada.",
    "500": "Ocorreu um erro.",
    "503": "Esta página está recebendo muitos visitantes no momento. Tente novamente mais tarde.",
    "btn001": "Voltar à página inicial.",
    "voted": "Você já fez a sua escolha."
  }
}